export default __webpack_public_path__ + "static/media/box-the-cto-game.a446b217.svg";